import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';

export class FormCd001ClassificacaoBuild {

    public async buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<FormGroup> {
        form = await this.buildFormI(form, arrForm[0], generalService);
        form = await this.buildFormII(form, arrForm[1], generalService);
        form = await this.buildFormIII(form, arrForm[2], generalService);
        form = await this.buildFormIV(form, arrForm[3], generalService);
        form = await this.buildFormV(form, arrForm[4], generalService);
        form = await this.buildFormVI(form, arrForm[5], generalService);
        return form;
    }

    private async buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('site').setValue(formCard.get('site')?.value ?? null);
        form.get('data_hora').setValue(generalService.createDateTimeData(formCard.get('data')?.value, formCard.get('hora')?.value));
        form.get('numero_controle').setValue(formCard.get('numero_controle')?.value ?? null);
        form.get('hibrido').setValue(formCard.get('hibrido')?.value ?? formCard.get('hibrido_rnc')?.value ?? null);
        form.get('processo').setValue(formCard.get('processo')?.value ?? null);
        form.get('processo_basica').setValue(formCard.get('processo_basica')?.value ?? null);
        form.get('lote_origem').setValue(formCard.get('lote_origem')?.value ?? null);
        // form.get('lote_ds').setValue(formCard.get('lote_ds')?.value??null);
        form.get('lote_cs').setValue(formCard.get('lote_cs')?.value ?? null);
        form.get('origem').setValue(formCard.get('origem')?.value ?? null);
        // form.get('umidade_ds_prc').setValue(formCard.get('umidade_ds_prc')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('safra').setValue(formCard.get('safra')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('peneira').setValue(formCard.get('peneira')?.value ?? null);
        form.get('peneira_basica').setValue(formCard.get('peneira_basica')?.value ?? null);
        form.get('destino').setValue(formCard.get('destino')?.value ?? null);
        form.get('basic').setValue(formCard.get('basic')?.value ?? null);
        // form.get('generation_id').setValue(formCard.get('generation_id')?.value ?? null);
        form.get('porcentagem_falha').setValue(formCard.get('porcentagem_falha')?.value ?? null);
        form.get('vazao').setValue(formCard.get('vazao')?.value ?? null);
        form.get('responsavel_especial').setValue(formCard.get('responsavel_especial')?.value ?? null);
        form.get('numero_campo').setValue(formCard.get('numero_campo')?.value ?? null);
        form.get('linha_processamento').setValue(formCard.get('linha_processamento')?.value ?? null);
        form.get('classe_basica').setValue(formCard.get('classe')?.value ?? null);
        form.get('umidade_media').setValue(formCard.get('umidade_media')?.value ?? null);
        form.get('geracao').setValue(formCard.get('geracao')?.value ?? null);
        form.get('lote_ds').setValue(formCard.get('lote_ds')?.value ?? null);
        form.get('turno').setValue(formCard.get('turno')?.value ?? null);


        return await form;
    }

    private async buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('retido_peneira_treze_meio_prc').setValue(formCard.get('retido_peneira_treze_meio_prc')?.value ?? null);
        form.get('retido_peneira_treze_prc').setValue(formCard.get('retido_peneira_treze_prc')?.value ?? null);
        form.get('retido_peneira_doze_meio_prc').setValue(formCard.get('retido_peneira_doze_meio_prc')?.value ?? null);
        form.get('retido_peneira_doze_prc').setValue(formCard.get('retido_peneira_doze_prc')?.value ?? null);
        form.get('retido_peneira_onze_meio_prc').setValue(formCard.get('retido_peneira_onze_meio_prc')?.value ?? null);
        form.get('vazado_peneira_corresp_oblongo_prc').setValue(formCard.get('vazado_peneira_corresp_oblongo_prc')?.value ?? null);

        return await form;
    }

    private async buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('retido_peneira_vinte_dois_prc').setValue(formCard.get('retido_peneira_vinte_dois_prc')?.value ?? null);
        form.get('retido_peneira_vinte_um_prc').setValue(formCard.get('retido_peneira_vinte_um_prc')?.value ?? null);
        form.get('retido_peneira_vinte_prc').setValue(formCard.get('retido_peneira_vinte_prc')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('retido_peneira_dezenove_prc').setValue(formCard.get('retido_peneira_dezenove_prc')?.value ?? null);
        // tslint:disable-next-line: max-line-length
        form.get('retido_peneira_dezoito_prc').setValue(formCard.get('retido_peneira_dezoito_prc')?.value ?? null);
        form.get('retido_peneira_dezessete_prc').setValue(formCard.get('retido_peneira_dezessete_prc')?.value ?? null);
        form.get('retido_peneira_dezesseis_prc').setValue(formCard.get('retido_peneira_dezesseis_prc')?.value ?? null);
        form.get('retido_peneira_quinze_prc').setValue(formCard.get('retido_peneira_quinze_prc')?.value ?? null);
        form.get('vazado_peneira_corresp_furo_redondo_prc').setValue(formCard.get('vazado_peneira_corresp_furo_redondo_prc')?.value ?? null);
        form.get('resultado_retencao').setValue(formCard.get('resultado_retencao')?.value ?? null);
        form.get('retido_peneira_r3_prc').setValue(formCard.get('retido_peneira_r3_prc')?.value ?? null);

        return await form;
    }

    private async buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('minimo_siaqs_mm').setValue(formCard.get('minimo_siaqs_mm')?.value ?? null);
        form.get('maximo_siaqs_mm').setValue(formCard.get('maximo_siaqs_mm')?.value ?? null);
        form.get('range_siaqs_mm').setValue(formCard.get('range_siaqs_mm')?.value ?? null);
        form.get('desvio_padrao_siaqs_mm').setValue(formCard.get('desvio_padrao_siaqs_mm')?.value ?? null);
        form.get('plantabilidade_siaqs_prc').setValue(formCard.get('plantabilidade_siaqs_prc')?.value ?? null);
        form.get('resultado_siaqs').setValue(formCard.get('resultado_siaqs')?.value ?? null);
        form.get('motivo_reprovacao_siaqs').setValue(formCard.get('motivo_reprovacao_siaqs')?.value ?? null);
        form.get('observacoes').setValue(formCard.get('observacoes')?.value ?? null);
        form.get('usuario').setValue(formCard.get('usuario')?.value ?? null);
        form.get('marca').setValue(formCard.get('marca')?.value ?? null);
        form.get('anel').setValue(formCard.get('anel')?.value ?? null);
        form.get('disco').setValue(formCard.get('disco')?.value ?? null);
        form.get('falha').setValue(formCard.get('falha')?.value ?? null);
        form.get('dupla').setValue(formCard.get('dupla')?.value ?? null);
        form.get('singulacao').setValue(formCard.get('singulacao')?.value ?? null);
        form.get('disco_recomendado_image_socidisco_maxim').setValue(formCard.get('disco_recomendado_image_socidisco_maxim')?.value ?? null);
        form.get('disco_recomendado_image_socidisco_tsi').setValue(formCard.get('disco_recomendado_image_socidisco_tsi')?.value ?? null);
        form.get('disco_recomendado_image_apollo_tsi').setValue(formCard.get('disco_recomendado_image_apollo_tsi')?.value ?? null);
        form.get('disco_recomendado_image_apollo_maxim').setValue(formCard.get('disco_recomendado_image_apollo_maxim')?.value ?? null);
        return await form;
    }

    private async buildFormV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {

        form.get('disco_apollo').setValue(formCard.get('disco_apollo')?.value ?? null);
        form.get('anel_apollo').setValue(formCard.get('anel_apollo')?.value ?? null);
        form.get('prc_falha_apollo').setValue(formCard.get('prc_falha_apollo')?.value ?? null);
        form.get('prc_dupla_apollo').setValue(formCard.get('prc_dupla_apollo')?.value ?? null);
        form.get('prc_singulacao_apollo').setValue(formCard.get('prc_singulacao_apollo')?.value ?? null);
        form.get('resultado_precision_planting').setValue(formCard.get('resultado_precision_planting')?.value ?? null);
        form.get('motivo_reprovacao_precision_planting').setValue(formCard.get('motivo_reprovacao_precision_planting')?.value ?? null);
        form.get('grafite').setValue(formCard.get('grafite')?.value ?? null);


        form.get('disco_socidisco').setValue(formCard.get('disco_socidisco')?.value ?? null);
        form.get('anel_socidisco').setValue(formCard.get('anel_socidisco')?.value ?? null);
        form.get('prc_falha_socidisco').setValue(formCard.get('prc_falha_socidisco')?.value ?? null);
        form.get('prc_dupla_socidisco').setValue(formCard.get('prc_dupla_socidisco')?.value ?? null);
        form.get('prc_singulacao_socidisco').setValue(formCard.get('prc_singulacao_socidisco')?.value ?? null);
        form.get('liberacao_especial').setValue(form.get('liberacao_especial')?.value != "" && form.get('liberacao_especial')?.value != null ? form.get('liberacao_especial')?.value : formCard.get('liberacao_especial')?.value ?? null);
        form.get('motivo_liberacao_especial').setValue(form.get('motivo_liberacao_especial')?.value != "" && form.get('motivo_liberacao_especial')?.value != null ? form.get('motivo_liberacao_especial')?.value : formCard.get('motivo_liberacao_especial')?.value ?? null);
        //form.get('anel_apollo_precision_planting').setValue(formCard.get('anel_apollo_precision_planting')?.value??null);
        form.get('created_by').setValue(formCard.get('criado_por')?.value ?? null);
        return await form;
    }

    private async buildFormVI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('responsavel_analise')?.setValue(formCard.get('responsavel_analise')?.value ?? null);
        form.get('previa_numero_passada_basica')?.setValue(formCard.get('previa_numero_passada_basica')?.value ?? null);
        form.get('regulagem_passe')?.setValue(formCard.get('regulagem_passe')?.value ?? null);
        form.get('liberacao_especial').setValue(form.get('liberacao_especial')?.value != "" && form.get('liberacao_especial')?.value != null ? form.get('liberacao_especial')?.value : formCard.get('liberacao_especial')?.value ?? null);
        form.get('motivo_liberacao_especial').setValue(form.get('motivo_liberacao_especial')?.value != "" && form.get('motivo_liberacao_especial')?.value != null ? form.get('motivo_liberacao_especial')?.value : formCard.get('motivo_liberacao_especial')?.value ?? null);
        form.get('responsavel_autorizacao_especial')?.setValue(formCard.get('responsavel_autorizacao_especial')?.value ?? null);
        form.get('avaliacao_retencao')?.setValue(formCard.get('avaliacao_retencao')?.value ?? null);
        form.get('avaliacao_precision_planting')?.setValue(formCard.get('avaliacao_precision_planting')?.value ?? null);
        form.get('usuario')?.setValue(formCard.get('usuario')?.value ?? null);
        return await form;
    }


    public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
        await this.updateFormI(form, arrForm[0], generalService);
        await this.updateFormII(form, arrForm[1], generalService);
        await this.updateFormIII(form, arrForm[2], generalService);
        await this.updateFormIV(form, arrForm[3], generalService);
        await this.updateFormV(form, arrForm[4], generalService);
        await this.updateFormVI(form, arrForm[5], generalService);
    }

    private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('site')?.setValue(data.formulario.site);
        // tslint:disable-next-line: max-line-length
        formCard.get('data')?.setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_hora, true));
        // tslint:disable-next-line: max-line-length
        formCard.get('hora')?.setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_hora, false));
        formCard.get('numero_controle')?.setValue(data.formulario.numero_controle);
        formCard.get('hibrido')?.setValue(data.formulario.hibrido);
        formCard.get('hibrido_rnc')?.setValue(data.formulario.hibrido);
        formCard.get('processo')?.setValue(data.formulario.processo);
        formCard.get('lote_origem')?.setValue(data.formulario.lote_origem);
        formCard.get('lote_ds')?.setValue(data.formulario.lote_ds);
        formCard.get('lote_cs')?.setValue(data.formulario.lote_cs);
        formCard.get('origem')?.setValue(data.formulario.origem);
        // formCard.get('umidade_ds_prc')?.setValue(data.formulario.umidade_ds_prc);
        formCard.get('safra')?.setValue(data.formulario.safra);
        formCard.get('peneira')?.setValue(data.formulario.peneira);
        formCard.get('destino')?.setValue(data.formulario.destino);
        formCard.get('basic')?.setValue(data.formulario.basic);
        // formCard.get('generation_id')?.setValue(data.formulario.generation_id);
        formCard.get('porcentagem_falha')?.setValue(data.formulario.porcentagem_falha);
        formCard.get('vazao')?.setValue(data.formulario.vazao);
        formCard.get('responsavel_especial')?.setValue(data.formulario.responsavel_especial);
        formCard.get('numero_campo')?.setValue(data.formulario.numero_campo);
        formCard.get('linha_processamento')?.setValue(data.formulario.linha_processamento);
        formCard.get('processo_basica')?.setValue(data.formulario.processo_basica);
        formCard.get('peneira_basica')?.setValue(data.formulario.peneira_basica);
        formCard.get('classe')?.setValue(data.formulario.classe_basica);
        formCard.get('geracao')?.setValue(data.formulario.geracao);
        formCard.get('umidade_media')?.setValue(data.formulario.umidade_media);
        formCard.get('turno')?.setValue(data.formulario.turno);

    }

    private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('retido_peneira_treze_meio_prc')?.setValue(data.formulario.retido_peneira_treze_meio_prc);
        formCard.get('retido_peneira_treze_prc')?.setValue(data.formulario.retido_peneira_treze_prc);
        formCard.get('retido_peneira_doze_meio_prc')?.setValue(data.formulario.retido_peneira_doze_meio_prc);
        formCard.get('retido_peneira_doze_prc')?.setValue(data.formulario.retido_peneira_doze_prc);
        formCard.get('retido_peneira_onze_meio_prc')?.setValue(data.formulario.retido_peneira_onze_meio_prc);
        formCard.get('vazado_peneira_corresp_oblongo_prc')?.setValue(data.formulario.vazado_peneira_corresp_oblongo_prc);
    }

    private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('retido_peneira_vinte_dois_prc')?.setValue(data.formulario.retido_peneira_vinte_dois_prc);
        formCard.get('retido_peneira_vinte_um_prc')?.setValue(data.formulario.retido_peneira_vinte_um_prc);
        formCard.get('retido_peneira_vinte_prc')?.setValue(data.formulario.retido_peneira_vinte_prc);
        formCard.get('retido_peneira_dezenove_prc')?.setValue(data.formulario.retido_peneira_dezenove_prc);
        // tslint:disable-next-line: max-line-length

        formCard.get('retido_peneira_dezoito_prc')?.setValue(data.formulario.retido_peneira_dezoito_prc);
        // tslint:disable-next-line: max-line-length
        formCard.get('retido_peneira_dezessete_prc')?.setValue(data.formulario.retido_peneira_dezessete_prc);
        // tslint:disable-next-line: max-line-length
        formCard.get('retido_peneira_dezesseis_prc')?.setValue(data.formulario.retido_peneira_dezesseis_prc);
        // tslint:disable-next-line: max-line-length
        formCard.get('retido_peneira_quinze_prc')?.setValue(data.formulario.retido_peneira_quinze_prc);
        formCard.get('vazado_peneira_corresp_furo_redondo_prc')?.setValue(data.formulario.vazado_peneira_corresp_furo_redondo_prc);
        formCard.get('resultado_retencao')?.setValue(data.formulario.resultado_retencao);
        formCard.get('retido_peneira_r3_prc')?.setValue(data.formulario.retido_peneira_r3_prc);
    }

    private async updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('minimo_siaqs_mm')?.setValue(data.formulario.minimo_siaqs_mm);
        formCard.get('maximo_siaqs_mm')?.setValue(data.formulario.maximo_siaqs_mm);
        formCard.get('range_siaqs_mm')?.setValue(data.formulario.range_siaqs_mm);
        formCard.get('desvio_padrao_siaqs_mm')?.setValue(data.formulario.desvio_padrao_siaqs_mm);
        formCard.get('plantabilidade_siaqs_prc')?.setValue(data.formulario.plantabilidade_siaqs_prc);
        formCard.get('resultado_siaqs')?.setValue(data.formulario.resultado_siaqs);
        formCard.get('motivo_reprovacao_siaqs')?.setValue(data.formulario.motivo_reprovacao_siaqs);
        // tslint:disable-next-line: max-line-length
        formCard.get('observacoes')?.setValue(data.formulario.observacoes);
        // tslint:disable-next-line: max-line-length
        formCard.get('usuario')?.setValue(data.formulario.usuario);
        formCard.get('marca')?.setValue(data.formulario.marca);
        formCard.get('anel')?.setValue(data.formulario.anel);
        formCard.get('disco')?.setValue(data.formulario.disco);
        formCard.get('falha')?.setValue(data.formulario.falha);
        formCard.get('dupla')?.setValue(data.formulario.dupla);
        formCard.get('singulacao')?.setValue(data.formulario.singulacao);
        formCard.get('disco_recomendado_image_socidisco_maxim')?.setValue(data.formulario.disco_recomendado_image_socidisco_maxim);
        formCard.get('disco_recomendado_image_socidisco_tsi')?.setValue(data.formulario.disco_recomendado_image_socidisco_tsi);
        formCard.get('disco_recomendado_image_apollo_maxim')?.setValue(data.formulario.disco_recomendado_image_apollo_maxim);
        formCard.get('disco_recomendado_image_apollo_tsi')?.setValue(data.formulario.disco_recomendado_image_apollo_tsi);
    }

    private async updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {

        formCard.get('disco_apollo')?.setValue(data.formulario.disco_apollo);
        formCard.get('anel_apollo')?.setValue(data.formulario.anel_apollo);
        formCard.get('prc_falha_apollo')?.setValue(data.formulario.prc_falha_apollo);
        formCard.get('prc_dupla_apollo')?.setValue(data.formulario.prc_dupla_apollo);
        formCard.get('prc_singulacao_apollo')?.setValue(data.formulario.prc_singulacao_apollo);
        formCard.get('resultado_precision_planting')?.setValue(data.formulario.resultado_precision_planting);
        formCard.get('motivo_reprovacao_precision_planting')?.setValue(data.formulario.motivo_reprovacao_precision_planting);
        formCard.get('grafite')?.setValue(data.formulario.grafite);
        formCard.get('disco_socidisco')?.setValue(data.formulario.disco_socidisco);
        formCard.get('anel_socidisco')?.setValue(data.formulario.anel_socidisco);
        formCard.get('prc_falha_socidisco')?.setValue(data.formulario.prc_falha_socidisco);
        formCard.get('prc_dupla_socidisco')?.setValue(data.formulario.prc_dupla_socidisco);
        formCard.get('prc_singulacao_socidisco')?.setValue(data.formulario.prc_singulacao_socidisco);
        formCard.get('disco_recomendado_image_apollo_maxim')?.setValue(data.formulario.disco_recomendado_image_apollo_maxim);
        formCard.get('liberacao_especial')?.setValue(data.formulario.liberacao_especial);
        formCard.get('motivo_liberacao_especial')?.setValue(data.formulario.motivo_liberacao_especial);
        //formCard.get('anel_apollo_precision_planting')?.setValue(data.formulario.anel_apollo_precision_planting);
        formCard.get('criado_por')?.setValue(data.formulario.created_by);
    }

    private async updateFormVI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('responsavel_analise')?.setValue(data.formulario.responsavel_analise);
        formCard.get('previa_numero_passada_basica')?.setValue(data.formulario.previa_numero_passada_basica);
        formCard.get('regulagem_passe')?.setValue(data.formulario.regulagem_passe);
        formCard.get('liberacao_especial')?.setValue(data.formulario.liberacao_especial);
        formCard.get('motivo_liberacao_especial')?.setValue(data.formulario.motivo_liberacao_especial);
        formCard.get('responsavel_autorizacao_especial')?.setValue(data.formulario.responsavel_autorizacao_especial);
        formCard.get('avaliacao_retencao')?.setValue(data.formulario.avaliacao_retencao);
        formCard.get('avaliacao_precision_planting')?.setValue(data.formulario.avaliacao_precision_planting);
        formCard.get('usuario')?.setValue(data.formulario.usuario);
        formCard.get('criado_por')?.setValue(data.formulario.created_by);
    }
}

